<template>
  <section>
    <div v-if="!isLoading && data && data.type" class="my-type-top-wrap">
      <div class="my-type-top">
        <div class="my-type-img"><img :src="filenameType(data.type)" alt=""/></div>
        <div class="my-type-desc">
          <p class="my-type-tit"><strong class="col-purple">{{data.type}}</strong> 타입이네요</p>
          <p class="my-type-text">{{data.analysisdate}}부터 어제까지 <template v-if="showThreeMonth">3개월간 </template>이용하신</p>
          <p class="my-type-text">총 {{data.vodviewtime | setNumberCommas}}시간의 이용내역을 바탕으로 분석한 내용이에요.</p>
        </div>
      </div>
    </div>
    <div v-else-if="!isLoading && data && !data.type" class="my-type-reload">
      <img src="../../assets/images/mypooq/icon-error-74.png" alt="">
      <p>
        {{data.joindate}} 가입 후<br>
        웨이브와 함께 한 시간이 없네요.<br><br>
        한 편이라도 5분 이상 시청하면 다음날 바로 분석 결과를 확인할 수 있어요!<br>
        시청 시간이 늘어날수록 드러나는 나만의 취향을 확인해 보세요.
      </p>
      <a href="#" @click.prevent="goToHome()" >홈으로 이동하기</a>
    </div>
  </section>
</template>

<script>
import { setNumberCommas } from '@/common/utils/common'

export default {
  props: {
    data: {
      type: Object
    },
    isLoading: {
      type: Boolean
    }
  },
  filters: {
    setNumberCommas
  },
  computed: {
    showThreeMonth () {
      if (!this.data) return ''

      let date = new Date()
      date.setMonth(date.getMonth() - 3)
      let joinDate = new Date(+this.data.joindate.substr(0, 4),
        (+this.data.joindate.substr(5, 2)) - 1, +this.data.joindate.substr(8, 2))
      return date > joinDate
    }
  },
  methods: {
    filenameType (type) {
      let filenamePath = require.context('../../assets/images/mypooq/', false, /\.png$/)
      let filename = ''

      switch (type) {
        case '본방사수형':
          filename = 'MYtype01'
          break
        case '주말 몰아보기형':
          filename = 'MYtype02'
          break
        case '최신 BROADCAST 바로보기형':
          filename = 'MYtype03'
          break
        case '영화 매니아형':
          filename = 'MYtype04'
          break
        case '느긋하게 다시보기형':
          filename = 'MYtype05'
          break
        case '종영작 정주행형':
          filename = 'MYtype06'
          break
        default:
          filename = 'MYtype01'
      }
      return filenamePath('./' + filename + '.png')
    },
    goToHome () {
      this.$router.push('/')
    }
  }
}
</script>
